import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=0e8b55ca&scoped=true"
import script from "./AddressEdit.vue?vue&type=script&lang=js"
export * from "./AddressEdit.vue?vue&type=script&lang=js"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=0e8b55ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8b55ca",
  null
  
)

export default component.exports